export const ADD_PARTICIPANT_DATA = "ADD_PARTICIPANT_DATA";
export const UPDATE_PLATFORM_PARTICIPANT = "UPDATE_PLATFORM_PARTICIPANT";
export const UPDATE_PLANNER_PARTICIPANT = "UPDATE_PLANNER_PARTICIPANT";
export const ADD_PARTICIPANT_ID = "ADD_PARTICIPANT_ID";

export const ADD_PARTICIPANT_DATA_FUNDING_SOURCE =
  "ADD_PARTICIPANT_DATA_FUNDING_SOURCE";
